import { render, staticRenderFns } from "./RemoveFromStopListDialog.vue?vue&type=template&id=69123dc0&scoped=true&"
import script from "./RemoveFromStopListDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveFromStopListDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoveFromStopListDialog.vue?vue&type=style&index=0&id=69123dc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69123dc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})
